export default __webpack_public_path__ + "static/media/anniversary.90e49746.webp";